import { removeAccents } from './string.utils';

export function copyToClipboard(value: string, event: Event, lowercase = false): void {
  const transformedValue = removeAccents(lowercase ? value.toLowerCase() : value.toUpperCase());

  const textarea = document.createElement('textarea');
  textarea.value = transformedValue;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);

  const button = event.currentTarget as HTMLElement;
  button.classList.add('copied');

  setTimeout(() => {
    button.classList.remove('copied');
  }, 1000);
}
